import SiteLayout from "@/components/feature/SiteLayout";
import { useSeo } from "@/hooks/useSeo";
import { brand, faqs } from "@/mocks/site";
import { featuredCaseIds, cases } from "@/mocks/cases";
import HeroSection from "@/pages/home/components/HeroSection";
import TopicTicker from "@/pages/home/components/TopicTicker";
import PropositionSection from "@/pages/home/components/PropositionSection";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import CategorySection from "@/pages/home/components/CategorySection";
import LatestSection from "@/pages/home/components/LatestSection";
import ProcessSection from "@/pages/home/components/ProcessSection";
import TestimonialSection from "@/pages/home/components/TestimonialSection";
import FaqPreviewSection from "@/pages/home/components/FaqPreviewSection";
import CtaSection from "@/pages/home/components/CtaSection";

const homeFaqs = faqs.slice(0, 5);
const featuredList = featuredCaseIds
  .map((id) => cases.find((item) => item.id === id))
  .filter((item): item is (typeof cases)[number] => Boolean(item));

export default function Home() {
  useSeo({
    title: "黑暗爆料 - 潜规则 · 圈内规则 · 行业黑幕 · 暗箱操作曝光",
    description:
      "黑暗爆料是一个聚焦行业潜规则、圈内规则、行业黑幕与暗箱操作的中文调查内容平台，按流程拆解消费陷阱、灰色地带与权力内幕的运作方式，为读者提供可对照的风险信息与避坑方法。",
    keywords: "黑暗爆料,行业黑幕,潜规则,圈内规则,暗箱操作,灰色地带,权力内幕,消费陷阱",
    path: "/",
    type: "website",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: brand.name,
        url: "https://i2785.cn/",
        description: brand.intro,
        potentialAction: {
          "@type": "SearchAction",
          target: "https://i2785.cn/cases?q={search_term_string}",
          "query-input": "required name=search_term_string",
        },
      },
      {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: brand.name,
        url: "https://i2785.cn/",
        email: brand.email,
        foundingDate: brand.since,
        description: brand.intro,
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "本周重点档案",
        itemListElement: featuredList.map((item, index) => ({
          "@type": "ListItem",
          position: index + 1,
          url: `https://i2785.cn/cases/${item.id}`,
          name: item.title,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: homeFaqs.map((faq) => ({
          "@type": "Question",
          name: faq.question,
          acceptedAnswer: { "@type": "Answer", text: faq.answer },
        })),
      },
    ],
  });

  return (
    <SiteLayout>
      <HeroSection />
      <TopicTicker />
      <PropositionSection />
      <FeaturedSection />
      <CategorySection />
      <LatestSection />
      <ProcessSection />
      <TestimonialSection />
      <FaqPreviewSection />
      <CtaSection />
    </SiteLayout>
  );
}